import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './LoginPage.css';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = async (provider) => {
    try {
      await login(provider);
      navigate('/');
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <h2>Sign In</h2>
        <p className="login-subtitle">
          Sign in to upvote and rate support themes
        </p>

        <div className="sso-buttons">
          <button 
            className="sso-button google"
            onClick={() => handleLogin('google')}
          >
            <span className="sso-icon">G</span>
            Continue with Google
          </button>

          <button 
            className="sso-button apple"
            onClick={() => handleLogin('apple')}
          >
            <span className="sso-icon"></span>
            Continue with Apple
          </button>

          <button 
            className="sso-button facebook"
            onClick={() => handleLogin('facebook')}
          >
            <span className="sso-icon">f</span>
            Continue with Facebook
          </button>
        </div>

        <div className="login-footer">
          <p>
            By signing in, you agree to our Terms of Service and Privacy Policy.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
